// react
import React from 'react'

// redux
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
    fetchCities,
  } from '~/redux/actions/app'

// antd
import { Card } from 'antd'

// components
import NewPostCard from '~/components/sider/NewPostCard'
import SiderNavigationCard from '~/components/sider/SiderNavigationCard'
import UserSuggestCard from '~/components/sider/UserSuggestCard'
import UserRanksCard from '~/components/sider/UserRanksCard'
import SiderPromoList from '~/components/sider/SiderPromoList'
import WechatGroupCard from '~/components/site/WechatGroupCard'
import SiteRulesCard from '~/components/site/SiteRulesCard'

import CityItemCard from '~/components/city/CityItemCard'

import SiteLayout from '~/components/layout/SiteLayout'
// import SitePageSlider from '~/components/site/SitePageSlider'

// utils
import { generateTitleWithSuffix } from '~/utils/seo'

const pageSider = (
    <div>
      <NewPostCard />
      <SiderNavigationCard />
      <UserSuggestCard />
      <UserRanksCard />
      <SiteRulesCard />
      <WechatGroupCard />
      <SiderPromoList />
    </div>
  )


const CityPage = props => {

    return (
        <SiteLayout
            pageSider={pageSider}
            description={generateTitleWithSuffix('城市')}>
             <Card className='city-head-box'>
                    <div className='city-head-arrow'></div>
                    这里的城市，将汇集更多的本地的工作机会。同时，社区的城市共建者，也协助开通了各地的城市分舵（微信群）， 在群里，我们更喜欢交流工作之外的话题：房价交通，教育医疗，工资水平乃至吃喝拉撒，结婚生娃... <br/>欢迎加入鸭：）
            </Card>
            
            
            <CityItemCard cities={props.cities} />
                       
        </SiteLayout>
    )
    
}

const mapStateToProps = (state) => ({})
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

CityPage.requireUser = () => false

CityPage.getInitialProps = async () => {
     
    const cities = await fetchCities()
  
    return { cities }
  }

export default connect(mapStateToProps, mapDispatchToProps)(CityPage)


